import Link from "next/link";
import Image from "next/image";
import { H3 } from "@/shared/components";
import { displayFontClassName } from "@/lib/fonts";
import { cn } from "@/lib/utils";
import { sectionGridCardImageClass } from "./blockSection";
import type { ProjectsTheme } from "./projectsTheme";
import type { ProjectItemType } from "./ProjectsBlock";

const cardPaddingClass =
  "px-4 py-10 md:px-6 md:pt-10 md:pb-12 desktop:px-10 desktop:py-20";

interface ProjectGridCardProps {
  project: ProjectItemType;
  theme: ProjectsTheme;
}

export function ProjectGridCard({ project, theme }: ProjectGridCardProps) {
  const isInteractive = Boolean(project.slug);

  const content = (
    <div
      className={cn(
        "flex h-full flex-col gap-6",
        cardPaddingClass,
        project.thumbnail && "group",
        isInteractive && "transition-colors"
      )}
    >
      {project.thumbnail && (
        <div className="relative aspect-[400/280] w-full overflow-hidden bg-muted">
          <Image
            className={sectionGridCardImageClass}
            src={project.thumbnail.src}
            alt={project.thumbnail.alt || project.title}
            title={project.thumbnail.title ?? undefined}
            fill
            sizes="(max-width: 767px) 100vw, (max-width: 1439px) 50vw, 33vw"
          />
        </div>
      )}
      <H3
        className={cn(
          displayFontClassName,
          "text-heading-3 font-bold leading-[1.2]",
          theme.headline,
          isInteractive && "transition-colors group-hover:text-primary"
        )}
      >
        {project.title}
      </H3>
    </div>
  );

  if (project.slug) {
    return (
      <Link href={`/proekty/${project.slug}`} className="block h-full">
        {content}
      </Link>
    );
  }

  return content;
}
